import './utils/shareSession'; // MUST be first — share session across tabs before any storage read
import './i18n';
import './utils/swalToast'; // patch SweetAlert notifications into top toasts (global)
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter, Route, Link } from 'react-router-dom';

/* [CF 2026-08-17 #5] Tell the browser to stop restoring scroll positions BEFORE
 * anything renders. useScrollTopOnRoute sets this too, but only from inside a
 * route effect — i.e. after React has mounted and after the browser has already
 * had its chance to restore. Setting it here closes that gap: the browser never
 * restores a position at all, on back or forward, and the hook is then only
 * responsible for putting the new page at the top. */
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
